// extracted by mini-css-extract-plugin
module.exports = {"container":"loading_container__2Ncun","container__loading":"loading_container__loading__37s4E","container__loading__text":"loading_container__loading__text__XwpFj"};